// src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import './HomePage.css';

const HomePage = () => {
  const [totalLevels, setTotalLevels] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0); // This will require Cloud Functions for accuracy in production
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      // Fetch total levels
      const levelsSnapshot = await getDocs(collection(db, 'puzzles'));
      setTotalLevels(levelsSnapshot.size);

      // NOTE: Fetching all users is a privileged operation.
      // For this simple dashboard, we'll count progress documents.
      // A production app would use a Cloud Function to count auth users.
      const usersSnapshot = await getDocs(collection(db, 'progress'));
      setTotalUsers(usersSnapshot.size);
      
      setLoading(false);
    };

    fetchMetrics();
  }, []);

  if (loading) {
    return <div className="page-content">Loading metrics...</div>;
  }

  return (
    <div className="page-content">
      <h1>Dashboard</h1>
      <div className="metrics-container">
        <div className="metric-card">
          <h2>Total Levels</h2>
          <p>{totalLevels}</p>
        </div>
        <div className="metric-card">
          <h2>Total Users</h2>
          <p>{totalUsers}</p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;